import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

const normalizeHex = (raw) => {
  if (!raw || typeof raw !== "string") return "#c5ced9";
  const t = raw.trim();
  if (!t) return "#c5ced9";
  const withHash = t.startsWith("#") ? t : `#${t}`;
  const hex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(withHash)
    ? withHash
    : "#c5ced9";
  return hex;
};

const columnsData = [
  {
    field: "category_name",
    headerName: "Name",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "category_description",
    headerName: "Description",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "category_color",
    headerName: "Color",
    flex: 1,
    minWidth: 100,
    maxWidth: 140,
    sortable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      const hex = normalizeHex(params.row.category_color);
      return (
        <div className="categoryColorCell">
          <span
            className="categoryColorSwatch"
            style={{ backgroundColor: hex }}
            title={hex}
            role="img"
            aria-label={`Category color ${hex}`}
          />
        </div>
      );
    },
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      maxWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Edit category"
              onClick={() => {
                setOpen(true);
                setSelectedRow(params.row);
              }}
            >
              <EditRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Delete category"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
